import type { ReactElement } from 'react'

/** Shimmering placeholder block. The caller sizes it. */
export function Skeleton({ className = '' }: { className?: string }): ReactElement {
	return <div className={`animate-pulse rounded bg-gray/15 ${className}`} />
}

/**
 * Suspense fallback for lazily-loaded route chunks (see `_layout.tsx`).
 *
 * Without it the buzola `<Outlet/>` falls back to `null`, so the content area
 * goes blank between navigations — the page frame has to be approximated here
 * because the route module that knows the real layout is exactly what is still
 * downloading.
 */
export function PageSkeleton(): ReactElement {
	return (
		<div role="status">
			<span className="sr-only">Načítá se…</span>
			<div className="wave-bottom relative mb-6 pb-3">
				<Skeleton className="h-9 w-72 max-w-full" />
				<Skeleton className="mt-3 h-4 w-96 max-w-full" />
			</div>
			<div className="space-y-3 rounded-lg border border-light-gray bg-white p-4 shadow-sm">
				<Skeleton className="h-8 w-full" />
				{Array.from({ length: 6 }, (_, row) => <Skeleton className="h-6 w-full" key={row} />)}
			</div>
		</div>
	)
}
